// Settings hub (app.settings._index.tsx) + billing (app.settings.billing.tsx)
// + the Growth-gated verification harness (app.settings.verification.tsx).
export const settings = {
  hub: {
    heading: "Settings",
    plan: {
      heading: "Plan",
      currentTierPrefix: "Current tier:",
      trialEnds: "Trial ends {{date}}",
      manageBillingButton: "Manage billing",
    },
    quoteNumbering: {
      heading: "Quote numbering",
      prefixLabel: "Prefix:",
    },
    priceLists: {
      heading: "B2B price lists",
      description:
        "Curate fixed per-variant prices and assign them to companies. New quotes prefill from the company's list.",
      manageButton: "Manage price lists",
    },
    verification: {
      heading: "Verification harness",
      runButton: "Run pricing rule verification",
    },
  },
  billing: {
    pageHeading: "Billing",
    gatedBanner: {
      prefix: "Unlock {{feature}} on the",
      suffix: "plan. Choose {{plan}} below to turn it on.",
      defaultFeature: "this feature",
    },
    gatedFeature: {
      PRO: "PO PDF parsing and AI price suggestions",
      GROWTH: "the AI counter-offer engine and pricing-rule verification",
    },
    currentPlan: {
      heading: "Current plan",
      youreOnPrefix: "You're on",
      trialEnds: "Trial ends {{date}}",
    },
    freePlanUsage: {
      heading: "Free plan usage",
      usedOfCap: "{{used}} of {{cap}}",
      usedInLast30Days: "free quotes used in the last 30 days",
      remainingSuffix: "— {{remaining}} remaining",
      limitReachedBanner:
        "You've reached the free limit. Upgrade to Starter for unlimited quotes — your existing quotes stay fully editable.",
    },
    choosePlan: {
      heading: "Choose a plan",
      description:
        "Plans are approved on Shopify's secure plan page — pick one there and you'll land right back here with everything unlocked.",
      freeForever: "$0 forever",
      perMonth: "/mo",
      currentPlanCta: "Current plan",
      switchToFreeCta: "Switch to Free on Shopify",
      chooseCta: "Choose {{name}} on Shopify",
    },
    // Flat keys (not a `bullets: string[]` array) — the `t()` translator only
    // resolves string leaves, so each bullet gets its own key; the route
    // assembles them back into an array via `buildTierDescriptions(t)`.
    tierDescriptions: {
      FREE: {
        bullet1: "The full quote → accept → draft-order workflow",
        bullet2: "Company directory, public quote links, negotiated pricing",
        bullet3: "Branded quote PDFs",
        bullet4: "Up to 5 quotes in any 30-day window",
      },
      STARTER: {
        bullet1: "Everything in Free, plus:",
        bullet2: "Unlimited quotes — no monthly cap",
        bullet3: "CSV bulk import + filtered export",
      },
      PRO: {
        bullet1: "Everything in Starter",
        bullet2: "PO PDF → draft order parsing with confidence-scored line matching",
        bullet3: "AI price suggestions — each quote line priced from the buyer's order history",
      },
      GROWTH: {
        bullet1: "Everything in Pro",
        bullet2: "AI counter-offer engine drafted from order history",
        bullet3: "Verification harness for pricing rules",
      },
    },
  },
  verification: {
    pageHeading: "Verification harness",
    gatedBanner: {
      prefix: "The verification harness is included in the",
      suffix: "tier.",
      upgradeLink: "Upgrade your plan",
    },
    whatThisDoes: {
      heading: "What this does",
      description:
        "Replays a set of pricing rules against historical orders for a given company. Tells you what fraction of past orders would have produced identical totals under the rules — useful before flipping a new rule set on live quotes.",
    },
    dispatchedBanner: {
      prefix: "Verification dispatched (run id",
      suffix: "). Results appear below in ~30s.",
    },
    runVerification: {
      heading: "Run verification",
      pricingRuleVersionLabel: "Pricing rule version",
      versionOption: "v{{version}} — {{date}}",
      companyIdLabel: "Company GID (optional, scoped run)",
      submitButton: "Run verification",
    },
    recentRuns: {
      heading: "Recent runs",
      empty: "No runs yet.",
      matchesText: "{{matches}}/{{inputCount}} matches",
    },
    errors: {
      versionRequired: "Pricing rule version required.",
      versionNotFound: "Pricing rule version not found for this shop.",
      dispatchFailed: "Couldn't reach the verification service. Try again, or contact support if it persists.",
    },
  },
};
